import React, { FC } from 'react';

import { Account, useGetPartnersQuery } from 'src/api/@generated/backend-api';

import { ChooseButton } from 'src/components/choose-button/choose-button';
import { i18n } from 'src/i18n';
import { buildingImageProps, personImageProps } from 'src/resources/images';
import { selectAccountActionCreator } from 'src/state/account/action-creators/select-account-action-creator';
import { goToStepActionCreator } from 'src/state/order/action-creators/go-to-step-action-creator';
import { OrderStep } from 'src/state/order/types';
import { useAppDispatch } from 'src/state/thunk-api';
import { PartnerUtils } from 'src/utils/partner-utils';
import { I18nUtils } from 'src/utils/i18n-utils';

import { StyledTitle } from './choose-account-button.styled';

interface Props {
  account: Account;
}

export const ChooseAccountButton: FC<Props> = (props) => {
  const {
    account,
    account: { partnerId, customerId, name },
  } = props;
  const { data: partners } = useGetPartnersQuery();
  const dispatch = useAppDispatch();
  const partner = partners && PartnerUtils.getPartnerById(partners, partnerId);

  const handleButtonClick = () => {
    dispatch(selectAccountActionCreator(account));
    dispatch(goToStepActionCreator(OrderStep.CHOOSE_SERVICE_LOCATION));
  };

  return (
    <ChooseButton
      onClick={handleButtonClick}
      title={
        <StyledTitle variant="paragraph2" component="p" data-hj-suppress={true}>
          {name}
        </StyledTitle>
      }
      items={[
        {
          text: I18nUtils.message(i18n.page.chooseAccount.customerId, { customerId }),
          icon: personImageProps,
        },
        ...(partner
          ? [
              {
                text: I18nUtils.message(i18n.page.chooseAccount.deliveredBy, { partnerName: partner.name }),
                icon: buildingImageProps,
              },
            ]
          : []),
      ]}
    />
  );
};
